import { render, staticRenderFns } from "./BuyBoxCountrySwitcher.vue?vue&type=template&id=1ca15cab&scoped=true"
import script from "./BuyBoxCountrySwitcher.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyBoxCountrySwitcher.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BuyBoxCountrySwitcher.vue?vue&type=style&index=0&id=1ca15cab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca15cab",
  null
  
)

export default component.exports